/**
 * 자기소개서 요약 — 챗봇(Ask AI) 자료 전용.
 * 화면 어디에도 렌더하지 않는다. 온디바이스 모델의 컨텍스트 창이 좁아
 * 원문 대신 라우트별로 나눈 요약만 공급한다.
 */

/** 기술별 자신 있는 부분 (tech 라우트) */
export const COVER_SKILLS = `기술별 자신 있는 부분:
- HTML5: 시맨틱 마크업 기반 구조화, 표준 입력 제약 속성으로 입력 단계부터 검증, 키보드만으로 모든 기능을 쓸 수 있는 서비스 구현 경험
- JavaScript/TypeScript: ES6+ 기반, 단일 책임 원칙으로 함수 분리. API 응답·컴포넌트 props에 타입을 정의해 팀원이 데이터 형태를 추측하지 않게 하는 것이 기본
- CSS/TailwindCSS: 반응형 UI, 상태 기반 인터랙션, transition·animation
- React/Next.js: 반복 로직은 커스텀 훅으로 추상화, UI는 데이터 기반 설계. CSR/SSR을 목적에 따라 선택하고 Open Graph·메타데이터로 검색 노출까지 다듬음
- API 연동: fetch·Axios, RESTful 협업 연동, Supabase 직접 구축, 스펙 없는 외부 API 분석 연동. 에러는 상태별 사용자 메시지와 다음 행동 안내까지가 범위
- 상태 관리: Zustand 전역 + useState 지역, 상태 범위를 필요 이상 넓히지 않는 기준. LocalStorage로 세션·설정 유지
- 실시간 통신: SSE 알림, Supabase Realtime 단체 채팅 구현`;

/** 사용자 경험을 위해 신경 쓴 사례 (project 라우트) */
export const COVER_UX = `사용자 경험 사례:
- 스켈레톤 UI(De:caffeine): 로딩 중 "게시글이 없습니다" 오안내 문제를 발견, 직접 조사해 팀에 제안하고 콘텐츠 자리에 1px 단위로 맞춰 적용
- 낙관적 업데이트: 좋아요를 클릭 즉시 화면에 반영. 이후 모든 프로젝트의 기본값. 반대로 중복 실행이 위험한 폼 제출은 응답까지 버튼 비활성화
- Toast UI로 모든 행동에 성공/실패 즉각 피드백
- 다크모드(DUNCOP): 게임 유저 다수가 다크모드를 쓴다는 통계를 근거로 시스템 테마 감지 + HTML 단계 선적용으로 첫 진입 번쩍임(FOUC) 해결. 모바일은 데이터 출력량을 PC와 다르게 설계
- OS별 폰트 렌더링 차이(De:caffeine): CSS transform 안티앨리어싱으로 완화`;

/** 가장 어려웠던 문제와 해결 과정 (project 라우트) */
export const COVER_TROUBLE = `가장 어려웠던 문제 (본인이 직접 꼽은 것):
Studium 소셜 로그인. 프론트는 토큰 기반 Auth였는데 OAuth는 response가 아니라 리다이렉트로 동작해 토큰을 받을 방법이 없었음.
1차 시도: 백엔드에 response body로 토큰 요청 → OAuth 구조상 불가 답변, 이때 OAuth를 제대로 공부하게 됨.
2차 시도: 리다이렉트 URL 쿼리에 토큰 요청 → 히스토리·로그 노출 보안 문제로 거절.
해결: 토큰 집착을 내려놓고, 앱 진입마다 로그인 상태를 확인하는 초기화 단계를 설계. 백엔드가 cookie로 인증한다는 점을 활용해 기존 내 정보 조회 API의 성공/실패로 로그인 여부를 판별하는 AuthInitializer를 앱 진입점에 구현 — 새 API 없이 전역 로그인 상태 동기화.
배움: OAuth 인가 흐름, cookie와 LocalStorage의 보안 차이, 모르는 구조에 기존 방식을 끼워 맞추면 실패한다는 것.

그 외 기술적으로 부딪힌 문제:
- DUNCOP: 같은 요청이 Postman은 되는데 브라우저에서만 차단 → CORS가 브라우저 단 제약임을 파악, Next.js API Route 프록시(BFF)로 서버 단 호출 우회
- 북적북적: 프론트 로직·네트워크 정상인데 조회 거부 → 원인이 데이터베이스 권한(Supabase RLS Policy)에 있음을 파악해 수정. 프론트 문제처럼 보여도 원인이 다른 계층일 수 있음을 학습`;

/** 협업·소통 (collab 라우트) */
export const COVER_COLLAB = `협업 도구와 방식: Slack과 Notion으로 소통하고, 스크럼 미팅으로 진행 상황을 공유한다. PR 기반 코드리뷰와 브랜치 전략을 운영한다.

협업에서 겪은 문제와 개선:
Studium 프론트엔드 리더로서 팀원 질문을 모아 백엔드에 전달하는 창구 역할이 병목이 됨 — 제3자가 옮기며 맥락이 흐려지고, 구두 논의는 논점을 벗어나며 주변 집중까지 깨뜨림.
소통 구조 자체를 바꾸자고 제안: 기능별 담당자를 명시하고, 이슈는 리더를 거치지 않고 담당자를 직접 태그해 텍스트로 남기는 방식.
결과: 전달 손실 제거, 질문하는 쪽도 문제를 한 번 정리하게 됨, 기록이 남아 같은 질문이 반복되지 않음.
배움: 어려운 문제일수록 푸는 방법만큼 묻고 답하는 방식이 중요하고, 소통의 비효율은 참는 게 아니라 개선을 제안해야 하는 대상.`;
